import { call, put, takeLatest } from "redux-saga/effects";
import {
  consumptionViewAllFailure,
  consumptionViewAllSuccess,
  wholesalerReportSuccess,
  wholesalerReportFailure,
  wholesalerReportSearchSuccess,
  wholesalerReportSearchFailure,
  wholesalerReportDateSearchSuccess,
  wholesalerReportDateSearchFailure,
  wholesalerMonthReportSuccess,
  wholesalerMonthReportFailure,
  wholesalerWeekReportSuccess,
  wholesalerWeekReportFailure,
  wholesalerMonthReportDateSearchSuccess,
  wholesalerMonthReportDateSearchFailure,
  wholesalerWeekReportDateSearchSuccess,
  wholesalerWeekReportDateSearchFailure,
} from "./ReportAction";
import {
  ViewAllConSumptionEffect,
  SearchWholesalerReportEffect,
  WholesalerDayDateSearchReportEffect,
  WholesalerDayReportEffect,
  WholesalerWeekReportEffect,
  WholesalerMonthReportEffect,
  WholesalerWeekDateSearchReportEffect,
  WholesalerMonthDateSearchReportEffect,
} from "./ReportEffect";
import {
  REPORT_CONSUMPTION_SHOTS_REQUEST,
  REPORT_WHOLESALER_MONTH_REPORT_REQUEST,
  REPORT_WHOLESALER_REPORT_REQUEST,
  REPORT_WHOLESALER_REPORT_SEARCH_REQUEST,
  REPORT_WHOLESALER_WEEK_REPORT_REQUEST,
  WHOLESALER_REPORT_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_MONTH_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_WEEK_DATE_SEARCH_REQUEST,
} from "./ReportTypes";

// View All Consumption
function* viewAllConsumptionSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const { pageNo, payload, search_key } = action;
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAllConSumptionEffect,
      payload,
      pageNo,
      search_key,
      config
    );

    yield put(consumptionViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(consumptionViewAllFailure({ errormessage: errorMessage }));
  }
}

// function* viewAllTransactionsSaga(action) {
//   try {
//     const token = localStorage.getItem("accessToken");

//     const config = token
//       ? { headers: { Authorization: `Bearer ${token}` } }
//       : {};
//     const response = yield call(
//       TransactionsEffect,
//       action.payload,
//       config
//     );

//     yield put(transactionsSuccess(response.data));
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.message || "Failed to fetch products";
//     yield put(transactionsFailure({ errormessage: errorMessage }));
//   }
// }

// View All Month Wholesaler report
function* viewAllMonthWholesalerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(WholesalerMonthReportEffect, action.payload, config);

    yield put(wholesalerMonthReportSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerMonthReportFailure({ errormessage: errorMessage }));
  }
}

// View All Week Wholesaler report
function* viewAllWeekWholesalerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(WholesalerWeekReportEffect, action.payload, config);

    yield put(wholesalerWeekReportSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerWeekReportFailure({ errormessage: errorMessage }));
  }
}

// View All Day Wholesaler report
function* viewAllDayWholesalerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(WholesalerDayReportEffect, action.payload, config);

    yield put(wholesalerReportSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerReportFailure({ errormessage: errorMessage }));
  }
}

// //Search
// function* viewAllSearchConsumptionSaga(action) {
//   try {
//     const token = localStorage.getItem("accessToken");

//     const config = token
//       ? { headers: { Authorization: `Bearer ${token}` } }
//       : {};
//     const response = yield call(
//       SearchConsumptionEffect,
//       action.payload,
//       config
//     );

//     yield put(consumptionShotsSearchSuccess(response.data));
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.message || "Failed to fetch products";
//     yield put(consumptionShotsSearchFailure({ errormessage: errorMessage }));
//   }
// }

// function* viewAllSearchTransactionsSaga(action) {
//   try {
//     const token = localStorage.getItem("accessToken");

//     const config = token
//       ? { headers: { Authorization: `Bearer ${token}` } }
//       : {};
//     const response = yield call(
//       SearchTransactionsEffect,
//       action.payload,
//       config
//     );

//     yield put(transactionsSearchSuccess(response.data));
//   } catch (error) {
//     const errorMessage =
//       error.response?.data?.message || "Failed to fetch products";
//     yield put(transactionsSearchFailure({ errormessage: errorMessage }));
//   }
// }

// View All Month Date Search Wholesaler report
function* viewAllMonthDateSearchWholesalerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      WholesalerMonthDateSearchReportEffect,
      action.payload,
      config
    );

    yield put(wholesalerMonthReportDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(
      wholesalerMonthReportDateSearchFailure({ errormessage: errorMessage })
    );
  }
}

// View All Week Date Search Wholesaler report
function* viewAllWeekDateSearchWholesalerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      WholesalerWeekDateSearchReportEffect,
      action.payload,
      config
    );

    yield put(wholesalerWeekReportDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(
      wholesalerWeekReportDateSearchFailure({ errormessage: errorMessage })
    );
  }
}

// View All Day Date Search Wholesaler report
function* viewAllDayDateSearchWholesalerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      WholesalerDayDateSearchReportEffect,
      action.payload,
      config
    );

    yield put(wholesalerReportDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(
      wholesalerReportDateSearchFailure({ errormessage: errorMessage })
    );
  }
}

// View All Search Wholesaler report
function* viewAllSearchWholesalerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      SearchWholesalerReportEffect,
      action.payload,
      config
    );

    yield put(wholesalerReportSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerReportSearchFailure({ errormessage: errorMessage }));
  }
}

export function* ConsumptionSaga() {
  yield takeLatest(REPORT_CONSUMPTION_SHOTS_REQUEST, viewAllConsumptionSaga);
  // yield takeLatest(REPORT_TRANSACTIONS_REQUEST, viewAllTransactionsSaga);
  yield takeLatest(
    REPORT_WHOLESALER_MONTH_REPORT_REQUEST,
    viewAllMonthWholesalerReportSaga
  );
  yield takeLatest(
    REPORT_WHOLESALER_WEEK_REPORT_REQUEST,
    viewAllWeekWholesalerReportSaga
  );
  yield takeLatest(
    REPORT_WHOLESALER_REPORT_REQUEST,
    viewAllDayWholesalerReportSaga
  );
  // yield takeLatest(REPORT_TRANSACTIONS_SEARCH_REQUEST, viewAllSearchConsumptionSaga);
  // yield takeLatest(REPORT_CONSUMPTION_SHOTS_SEARCH_REQUEST, viewAllSearchTransactionsSaga);
  yield takeLatest(
    REPORT_WHOLESALER_REPORT_SEARCH_REQUEST,
    viewAllSearchWholesalerReportSaga
  );
  yield takeLatest(
    WHOLESALER_REPORT_MONTH_DATE_SEARCH_REQUEST,
    viewAllMonthDateSearchWholesalerReportSaga
  );
  yield takeLatest(
    WHOLESALER_REPORT_WEEK_DATE_SEARCH_REQUEST,
    viewAllWeekDateSearchWholesalerReportSaga
  );
  yield takeLatest(
    WHOLESALER_REPORT_DATE_SEARCH_REQUEST,
    viewAllDayDateSearchWholesalerReportSaga
  );
  yield takeLatest(
    REPORT_WHOLESALER_REPORT_SEARCH_REQUEST,
    viewAllSearchWholesalerReportSaga
  );
}
